import React, {Component, Fragment} from 'react';
import {
    selectLinkedAccounts,
    selectLinkedAccountsError,
    selectLinkedAccountsLoading, selectLinkedUsers,
    selectAuth
} from "../selectors";
import {
    getAccountDistributionMethod, getAccountTypeDistributionMethods,
    getAutoPayAvailableCC,
    getMyAmounts,
    getMyAutoPayInfo,
    getMyInvoices,
    getMyOrders,
    getMyServiceInfo
} from "../actions/homeInfoActions";
import {getCurrentPaymentProviderSupportsPaymentMethodStorage} from "../actions/paymentProviderActions";
import {getUserPermissions} from "../actions/authActions";
import {toggleIsActive, unlinkCurrentUserFromAccount, linkUserToAccount, fetchLinkedAccounts, fetchLinkedUsers} from "../actions/linkedAccountsInfoActions";
import {getAccountInfoById} from "../actions/accountInfoActions";
import {connect} from "react-redux";
import {toastr} from "react-redux-toastr";
import {Form, Formik} from "formik";
import * as Yup from "yup";


class LinkedAccountTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            accountNumber: '',
            email: '',
            successLinkingMessage: '',
            errorLinkingMessage: '',
            warningLinkingMessage: ''
        };
    }


    componentDidUpdate(prevProps) {
        if (this.props.resetForm !== prevProps.resetForm && this.props.resetForm) {
            this.resetForm();
            this.props.handleResetForm();
        }
    }

    handleInputChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    handleLinkAccount = (values) => {
        const { linkedAccounts } = this.props;
        const accountNumber = values.accountNumber;
        const email = values.email;
        const accountExists = linkedAccounts.linkedAccountList.some(account => account.accountInfo.accountNumber === Number(accountNumber));

        if (accountExists) {
            this.setState({
                warningLinkingMessage: 'Account already exists please try another one.'
            })

        } else {
            toastr.confirm('Are you sure you want to link account?', {
                cancelText: 'Cancel',
                okText: 'Confirm',
                onOk: async () => {
                    try {
                        const response = await linkUserToAccount(accountNumber, email, this.props.systemUserId)
                        this.setState({
                            accountNumber: '',
                            email: '',
                            successLinkingMessage: `If information provided matches our records an email will be sent out to account holder ${accountNumber} to finish the linking process.`
                        });
                    } catch (error) {
                        toastr.error(error)
                        this.setState({
                            errorLinkingMessage: error
                        })
                    }
                }
            })
        }


    }

    resetForm = () => {
        this.setState({
            accountNumber: '',
            email: '',
            successLinkingMessage: '',
            errorLinkingMessage: '',
            warningLinkingMessage:''
        });
    }

    handleUnlink = (accountId, systemUserId, userId, accountNumber, userName) => {

        toastr.confirm(`Are you sure you want to unlink account #${accountNumber} from ${userName}?`, {
            cancelText: 'Cancel',
            okText: 'Confirm',
            onOk: async () => {
                try {
                    const response = await unlinkCurrentUserFromAccount(accountId, systemUserId, userId);
                    this.props.fetchLinkedAccounts(systemUserId)
                } catch (error) {
                    console.error(error);
                }
            }
        })


    }

    handleUnlinkUser = (accountId, systemUserId, userId, accountNumber, userName) => {
        toastr.confirm(`Are you sure you want to unlink user ${userName} from account #${accountNumber}?`, {
            cancelText: 'Cancel',
            okText: 'Confirm',
            onOk: async () => {
                try {
                    const response = await unlinkCurrentUserFromAccount(accountId, userId, systemUserId);
                    this.props.fetchLinkedUsers(accountId)
                } catch (error) {
                    console.error(error);
                }
            }
        })


    }

    resetMessages = () => {
        this.setState({
            successLinkingMessage: '',
            errorLinkingMessage: '',
            warningLinkingMessage: ''
        });
    }

    render() {
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let unLinkUserId = this.props.currUser.userid;
        let unlinkAccountId = currentUser.accountId

        const {linkedAccounts, linkedUsers} = this.props

        const LinkAccountSchema = Yup.object().shape({
            accountNumber: Yup.string()
                .required('Account number is required'),
            email: Yup.string()
                .email('Invalid email')
                .required('Email is required'),
        });


        return (
            <div className="text-secondary">
                <h4>Linked Accounts</h4>

                <hr/>

                <Formik
                    initialValues={{
                        accountNumber: this.state.accountNumber,
                        email: this.state.email,
                    }}
                    validationSchema={LinkAccountSchema}
                    onSubmit={(values) => this.handleLinkAccount(values)}
                    validateOnBlur={false}
                    validateOnChange={false}
                >
                    {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting,resetForm }) =>
                    {
                        this.props.onFormikInteraction(resetForm);

                        return (
                        <form onSubmit={handleSubmit}>
                            <div className="form-row">
                                <div className="form-group col-sm-5">
                                    <label>Account #</label>
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text"><i className="fa fa-university"
                                                                                  aria-hidden="true"></i></span>
                                        </div>
                                        <input
                                            type="text"
                                            data-type="number"
                                            name="accountNumber"
                                            className={`form-control ${errors.accountNumber && touched.accountNumber ? 'is-invalid' : ''}`}
                                            value={values.accountNumber}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {errors.accountNumber && touched.accountNumber &&
                                            <div className="invalid-feedback">{errors.accountNumber}</div>}
                                    </div>
                                </div>

                                <div className="form-group col-sm-7">
                                    <label>Email</label>
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text"><i className="fa fa-envelope"
                                                                                  aria-hidden="true"></i></span>
                                        </div>
                                        <input
                                            type="text"
                                            data-type="currency"
                                            name="email"
                                            className={`form-control ${errors.email && touched.email ? 'is-invalid' : ''}`}
                                            value={values.email}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {errors.email && touched.email &&
                                            <div className="invalid-feedback">{errors.email}</div>}
                                    </div>
                                </div>

                                <div className="form-group col-12 text-right">
                                    <div className="btn-group-sm">
                                        <button
                                            className="btn btn-primary"
                                            id="btn-pmnt-submit"
                                            type="submit"
                                        >
                                            Link Account
                                        </button>

                                    </div>

                                    <hr/>
                                </div>

                                {(this.state.successLinkingMessage || this.state.errorLinkingMessage || this.state.warningLinkingMessage) && (
                                    <div className="form-group col-12">
                                        {this.state.successLinkingMessage &&
                                            <p className="text-success">{this.state.successLinkingMessage}</p>}
                                        {this.state.errorLinkingMessage &&
                                            <p className="text-danger">{this.state.errorLinkingMessage}</p>}
                                        {this.state.warningLinkingMessage &&
                                            <p className="text-warning">{this.state.warningLinkingMessage}</p>}


                                        <hr/>
                                    </div>
                                )}


                            </div>
                        </form>
                    )}}
                </Formik>


                {this.props.linkedAccounts && this.props.linkedAccounts.linkedAccountList && this.props.linkedAccounts.linkedAccountList.length > 0 && this.props.linkedAccounts.linkedAccountList.every(account => account.registeredDatetime) ? (
                    <div className="table-responsive mt-4">
                        <span>You have access to the following accounts.</span>
                        <hr/>
                        <table className="table cp-table cp-table-primary table-customer-payments">
                            <thead>
                            <tr>
                                <th>Customer</th>
                                <th>Account #</th>
                                <th>Action</th>

                            </tr>
                            </thead>
                            <tbody>
                            {this.props.linkedAccounts.linkedAccountList.map((account) => (
                                <tr key={account.id}>
                                    <td className="v-align-m">
                                        {account.accountInfo.accountType === "Business" ? account.accountInfo.companyName : account.accountInfo.contactName}
                                    </td>
                                    <td className="v-align-m">
                                        <strong>
                                            {account.accountInfo.accountNumber}
                                        </strong>

                                    </td>
                                    <td >

                                        <button
                                            className="btn btn-sm btn-primary"
                                            onClick={() => this.handleUnlink(account.accountInfo.accountId, account.systemUserId, account.systemUserId, account.accountInfo.accountNumber, account.systemUserContactName)}
                                        >
                                            <i className="fa fa-unlink" aria-hidden="true"></i>
                                        </button>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                ) : null}


                {this.props.linkedUsers && this.props.linkedUsers.linkedAccountList && this.props.linkedUsers.linkedAccountList.length > 0 && this.props.linkedUsers.linkedAccountList.every(account => account.registeredDatetime) ? (
                    <div className="table-responsive mt-4">
                        <span>These users have access to your account.</span>
                        <hr/>
                        <table className="table cp-table cp-table-primary">
                            <thead>
                            <tr>
                                <th>Customer</th>
                                <th>Account #</th>
                                <th>Action</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.props.linkedUsers.linkedAccountList.map((user) => (
                                <tr key={user.id}>
                                    <td className="v-align-m">
                                        {user.systemUserContactName}
                                    </td>
                                    <td className="v-align-m">
                                        <strong>
                                            {user.systemUserContactAccountNumbers[0]}
                                        </strong>
                                    </td>
                                    <td className="v-align-m">
                                        <button
                                            className="btn btn-sm btn-primary"
                                            onClick={() => this.handleUnlinkUser(user.accountInfo.accountId, user.systemUserId, unLinkUserId, user.accountInfo.accountNumber, user.systemUserContactName )}
                                        >
                                            <i className="fa fa-unlink" aria-hidden="true"></i>
                                        </button>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                ) : null}

            </div>
        );

    }
}

const mapStateToProps = (state) => {

    const linkedUsers = selectLinkedUsers(state);
    const

        linkedAccounts = selectLinkedAccounts(state),
        loading = selectLinkedAccountsLoading(state),
        error = selectLinkedAccountsError(state);
    const currUser = selectAuth(state);


    return {
        linkedAccounts,
        loading,
        error,
        linkedUsers,
        currUser

    }
};

const mapDispatchToProps = {
    getMyServiceInfo,
    getMyOrders,
    getMyInvoices,
    getMyAmounts,
    getMyAutoPayInfo,
    getAutoPayAvailableCC,
    getAccountDistributionMethod,
    getAccountTypeDistributionMethods,
    getCurrentPaymentProviderSupportsPaymentMethodStorage,
    getUserPermissions,
    fetchLinkedAccounts,
    getAccountInfoById,
    toggleIsActive,
    fetchLinkedUsers


};


export default connect(mapStateToProps, mapDispatchToProps)(LinkedAccountTable);